import { features } from 'reactApp/mail-features';

// CLOUDWEB-19554
// Обновленные коммуникации оверквотников
export const overquotaNewCommunication = features.has('overquota-new-communication');

const defaultOverquotaMoreInfoUrl = overquotaNewCommunication
    ? 'https://help.mail.ru/cloud_web/files/overflowing/'
    : 'https://help.mail.ru/legal/terms/cloud/la/';

export const overquotaMoreInfoUrl = features.getAsURL('overquota-more-info-url', defaultOverquotaMoreInfoUrl);
